import React from "react";
import { Card } from "@UI/Components/Card/Card";
import { ServiceOfferDescriptionProps } from "./types";
import { LoadingScreen } from "@UI/Components/LoadingScreen/LoadingScreen";
import { ServiceOfferItem } from "../../../Purchasing/Components/OrderDescription/OrderDescriptionItems/ServiceOfferItem";
import { List } from "@UI/Components/List/List";
import { TotalServiceOffer } from "./TotalServiceOffer";
import { useServiceOffer } from "@modules/ServiceAssignment/hooks/useServiceOffer";
import { AdvancePaymentItem } from "./AdvancePaymentItem";
import { EstimationState } from "@modules/ServiceRequest/types";
import { useServiceProvider } from "@modules/ServiceProviders/hooks/useServiceProvider";
import { VisitOfferDetail } from "@modules/ServiceRequest/Components/VisitOfferDetail";

// The showServiceFees and showAdvancePayment props are used for the serviceOffer Modal.
// In that step(When the SP has made an offer, we don't want to show the fees or advance payment yet)
export const ServiceOfferDescription = ({
  serviceOfferId,
  showServiceFees = true,
  showAdvancePayment = true,
  colorScheme,
  ...props
}: ServiceOfferDescriptionProps) => {
  // const { currentUser, isLoading: isLoadingCurrentUser } = useCurrentUser();

  // const { serviceFeesFeature, isLoading: isServiceFeesLoading } =
  //   useServiceFeesFeature();

  // const serviceFeePercentage =
  //   serviceFeesFeature?.details?.chargedToClient?.clientServiceFee?.percentage;

  const { serviceOffer, isLoading } = useServiceOffer(serviceOfferId);

  const { serviceProvider } = useServiceProvider(
    serviceOffer?.serviceProviderId,
    {
      includes: ["user"],
    }
  );

  const serviceProviderName = serviceProvider?.user?.firstName;

  // if (isLoading || isServiceFeesLoading || isLoadingCurrentUser) {
  //   return <LoadingScreen />;
  // }

  if (isLoading) {
    return <LoadingScreen />;
  }

  if (!serviceOffer) return;

  const {
    rateCents,
    rateCurrency,
    billingCount,
    billingUnit,
    expenses,
    prepaidCents,
  } = serviceOffer;

  return (
    <Card
      background={colorScheme === "sand" ? "sand.100" : "transparent"}
      shadow="none"
      padding={0}
      {...props}
    >
      {serviceOffer?.rateType === "estimate" &&
        (serviceOffer?.state === "waiting" ||
          serviceOffer?.estimationState === EstimationState.NOT_SENT) && (
          <VisitOfferDetail name={serviceProviderName} />
        )}

      <List>
        {(serviceOffer?.rateType !== "estimate" ||
          (serviceOffer.state === "accepted" &&
            serviceOffer.estimationState !== EstimationState.NOT_SENT)) && (
          <ServiceOfferItem
            preview
            priceCents={rateCents}
            currency={rateCurrency}
            billingCount={billingCount}
            billingUnit={billingUnit}
            expenses={expenses}
            serviceProviderId={serviceOffer?.serviceProvider?.id}
          />
        )}
        {showAdvancePayment && (
          <AdvancePaymentItem prepaidCents={prepaidCents} />
        )}

        {/* {!currentUser.subscribed && (
          <ClientProtectionFeeDetails
            isSubscribed={currentUser?.subscribed}
            serviceFeePercentage={serviceFeePercentage}
            serviceOffer={serviceOffer}
          />
        )} */}

        {/* <TotalServiceOffer
          isSubscribed={currentUser?.subscribed}
          serviceOfferId={serviceOfferId}
          colorScheme={colorScheme}
          includeAdvancePayment={showAdvancePayment}
          preview
        /> */}

        {/* {currentUser.subscribed && (
          <ClientProtectionFeeDetails
            isSubscribed={currentUser?.subscribed}
            serviceFeePercentage={serviceFeePercentage}
            serviceOffer={serviceOffer}
          />
        )} */}

        <TotalServiceOffer
          serviceOfferId={serviceOfferId}
          colorScheme={colorScheme}
          includeFees={showServiceFees}
          includeAdvancePayment={showAdvancePayment}
          preview
        />
      </List>
    </Card>
  );
};
